import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-blocked-vehicles',
  templateUrl: 'blocked-vehicles.html',
})
export class BlockedVehiclesPage {
  public vehicles: { 
    vehicle_id: string, 
    license_plate: string,
    v_display_name: string
  };
  public siteCode: string;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
    ) {
  }
  
  public ionViewWillEnter() {
    this.vehicles = this.navParams.data[0].data;
    this.siteCode = this.navParams.data[1];
  }

  public cancel() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/blocked-vehicles/blocked-vehicles.ts